import { useCallback, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";

import Notification from "../notification";

import { W3Context } from "../../services/context";
import jwtService from "../../services/jwt";
import WebsocketClient from "../../services/websocket";

const Notifications = () => {
  const { active, account } = useContext(W3Context);

  const [token, setToken] = useState(null);

  const connectWebsocket = useCallback(() => {
    if (!token) {
      return;
    }

    let ws = WebsocketClient(token);

    ws.addEventListener("message", (data) => {
      const notification = JSON.parse(data.data);
      console.log("notification ", notification);

      toast(
        <Notification
          text={notification.messageText}
          buttonLabel={notification.buttonText}
          link={`${notification.tokenId}`}
        />
      );
    });

    ws.addEventListener("close", () => {
      connectWebsocket();
    });

    ws.addEventListener("error", (error) => {
      console.log("Websocket error: ", error);
    });

    const closeConnection = () => {
      ws.close();
    };

    window.addEventListener("beforeunload", closeConnection);

    return () => {
      window.removeEventListener("beforeunload", closeConnection);
    };
  }, [token]);

  useEffect(() => {
    if (!active || !account) {
      return;
    }
    setToken(jwtService.sign({ id: account, role: "User" }));
    connectWebsocket();
  }, [account, active, connectWebsocket]);

  return <></>;
};

export default Notifications;
